import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { getLeaveDetailsList } from "../ApplyLeave/leaveService";
import { getWFHDetails } from "../ApplyLeave/Wfh/WfhSerevice";
import { orgSettings } from "../../../Services/Global-Services/GlobalServices";
import { TostMsg } from "../../../App";
import { InputSwitch } from "primereact/inputswitch";
import {
  Link,
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { useDispatch } from "react-redux";
import { setLeaveRequestData } from "../../../Services/Redux/DataTransferToAnother";

let leaveDetailData;

const MyCalendarComponent = () => {
  const [leaveEvents, setLeaveEvents] = useState([]);
  const [resources, setResources] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let Sdate = null;
  let EDate = null;
  const [filterStartDate, setFilterStartDate] = useState(Sdate);
  const [filterEndDate, setFilterEndDate] = useState(EDate);
  const [start, setStart] = useState(new Date());
  const [end, setEnd] = useState(new Date());
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState("");
  const [state, setState] = useState(new Date());
  const [isChecked, setIsChecked] = useState(false);
  const [currentEvents, setCurrentEvents] = useState([]);
  const [backPath, setBackPath] = useState("");
  const toster = useContext(TostMsg);
  const defaultImage = "/images/placeholder_profile.png";
  const [events, setEvents] = useState([
    { id: "1", title: "Meeting", start: new Date() },
    { id: "2", title: "Conference", start: "2025-04-05" },
  ]);
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (location.pathname === "/LeaveDashboard/Calendar") {
      setBackPath("LeaveDashboard");
    } else if (location.pathname === "/WFHDashboard/Calendar") {
      setBackPath("WFHDashboard");
    } else {
      setBackPath("Dashboard");
    }
    OrgSettings();
  }, []);


  useEffect(() => {
    if (isChecked) {
      setTimeout(() => {
        getLeaveData(1, "U", userDetails?.EmpId);
      }, 500);
    } else {
      setTimeout(() => {
        getLeaveData(3, "U", 0);
      }, 500);
    }
  }, [filterStartDate, filterEndDate, isChecked]);

  const OrgSettings = useCallback(async () => {
    let param = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let response = await orgSettings(param);
      let StartDate = response?.Data?.filter(
        (element) => element.KeyName === "LeaveFilterStartDate",
      );
      if (StartDate[0]?.Value != null) {
        Sdate = new Date(StartDate[0]?.Value)?.toISOString()?.split("T")[0];
      } else {
        Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
          ?.toISOString()
          ?.split("T")[0];
      }
      setFilterStartDate(Sdate);
      let EndDate = response?.Data?.filter(
        (element) => element?.KeyName === "LeaveFilterEndDate",
      );
      if (EndDate[0]?.Value != null) {
        EDate = new Date(EndDate[0]?.Value)?.toISOString()?.split("T")[0];
      } else {
        EDate = new Date()?.toISOString()?.split("T")[0];
      }
      setFilterEndDate(EDate);
    } catch (error) {
      setIsloading(false);
    }
  }, []);

  async function getLeaveData(type, category, emp) {
    setIsloading(true);
    let loggedInEmpId;
    if (isChecked) {
      loggedInEmpId = emp;
    } else {
      if (userDetails?.OverseerId !== 0) {
        loggedInEmpId = userDetails?.OverseerId;
      } else {
        loggedInEmpId = userDetails?.EmpId;
      }
    }
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: loggedInEmpId,
      EmpId: emp,
      LeaveId: 0,
      HierarchyTypeId: type,
      leavecategory: category,
      FilterStartDate: new Date(filterStartDate).toISOString(),
      FilterEndDate: new Date(filterEndDate).toISOString(),
      pageNumber: 1,
      pageSize: 1000000,
    };
    try {
      const data = await getLeaveDetailsList(param);
      leaveDetailData = await data?.Data;
      if (leaveDetailData) {
        getWFHData(type, category, emp);
      }
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function getWFHData(type, category, emp) {
    setIsloading(true);
    let loggedInEmpId;
    if (isChecked) {
      loggedInEmpId = emp;
    }
    else if (userDetails?.OverseerId == 0) {
      loggedInEmpId = userDetails?.EmpId;
    } else {
      loggedInEmpId = userDetails?.OverseerId;
    }
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: loggedInEmpId,
      WFHid: 0,
      EmpId: emp,
      HierarchyTypeId: type,
      FilterStartDate: new Date(filterStartDate).toISOString(),
      FilterEndDate: new Date(filterEndDate).toISOString(),
      pageNumber: 1,
      pageSize: 1000000,
      WFHcategory: category,
    };
    try {
      const response = await getWFHDetails(param);
      let addKeyInWFHList = response?.Data?.map((item) => ({
        ...item,
        IsWFH: 1,
      }));
      let Arr = [...addKeyInWFHList, ...leaveDetailData];
      setIsloading(false);
      console.log(Arr)
      setLeaveData(Arr);
    } catch {
      setIsloading(false);
    }
  }

  useEffect(() => {
    let leaveEventsList;
    let resourcesList;
    console.log(leaveData, "test...")
    if (leaveData?.length > 0) {
      leaveEventsList = leaveData.map((item) => {
        console.log(item)
        const startDate = moment(item.StartDate).startOf("day");
        let endDate = moment(item.EndDate).startOf("day");
        if (!item.IsHalfDay) {
          endDate = endDate.add(1, "days");
        }
        return {
          id: item.Id,
          EmpId: item.EmpId,
          resourceId: item.Id,
          HalfPreference: item.HalfPreference,
          WFHStatusName: item.WFHStatusName,
          LeaveStatusName: item.LeaveStatusName,
          IsHalfDay: item.IsHalfDay,
          Reason: item.Reason,
          WFHTypeId: item?.IsWFH,
          title: item.EmployeeName,
          profileImage: item.ProfileImage,
          createdByName: item.EmployeeName,
          StartDate: item.StartDate,
          EndDate: item.EndDate,
          start: startDate.toISOString(),
          end: endDate.toISOString(),
          backgroundColor: "white",
          textColor: "black",
        };
      });
      setLeaveEvents(leaveEventsList);

      resourcesList = leaveData?.map((item) => {
        return {
          id: item.Id,
          title: item.EmployeeName,
        };
      });
      setResources(resourcesList);
    }
  }, [leaveData]);

  const userLeave = (value) => {
    dispatch(setLeaveRequestData(value));
    history.push("/TeamLeave");
  };

  const userWFH = (value) => {
    dispatch(setLeaveRequestData(value));
    history.push("/TeamWfh");
  };

  const renderEventContent = (eventInfo) => {
    const { event } = eventInfo;
    console.log(event.extendedProps);
    const profileImage = event.extendedProps.profileImage;
    const createdByName = event.extendedProps.createdByName;
    const LeaveReason = event.extendedProps.Reason;
    const halfPreferenceStatus = event.extendedProps.HalfPreference;
    const upDateWFHStatus = event.extendedProps.WFHStatusName;
    const upDateLeaveStatus = event.extendedProps.LeaveStatusName
    const halfDay = event.extendedProps.IsHalfDay;
    if (event.extendedProps.WFHTypeId === 1) {
      return (
        <div
          // onClick={() => userWFH(event.extendedProps)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.2rem",
            fontSize: "11px",
            backgroundColor: "#ec411917",
            fontWeight: "500",
            color: "#ff0606",
            padding: "2px 14px 2px 4px",
            borderRadius: "29px",
          }}
        >
          <img
            src={profileImage || defaultImage}
            alt={createdByName}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = defaultImage;
            }}
            width="14"
            height="14"
            style={{ borderRadius: "50%" }}
          />
          <span className="hover-calender">
            {createdByName}
            <div className="hover-content-bx">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span className="leave-hover">
                  <div className="leave-popup">
                    {!halfDay && <span>Half Day : No</span>}

                    {halfDay && (
                      <>
                        {halfPreferenceStatus === "1" && <span>Half Day : First Half</span>}
                        {halfPreferenceStatus === "2" && <span>Half Day : Second Half</span>}
                      </>
                    )}

                    {/* {!halfDay && (
                      <p>
                        <strong>Half:</strong>{" "}
                        {halfPreferenceStatus == 1
                          ? "Second Half"
                          : "First Half"}
                      </p>
                    )} */}
                    {upDateWFHStatus && (
                      <p>
                        <strong>Status:</strong> {upDateWFHStatus}
                      </p>
                    )}

                  </div>
                </span>
              </div>
            </div>
          </span>
        </div>
      );
    } else {
      return (
        <div
          // onClick={() => userLeave(event.extendedProps)}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.2rem",
            color: "rgb(75 21 193)",
            fontSize: "11px",
            fontWeight: "500",
            backgroundColor: "#671cc91f",
            padding: "2px 14px 2px 4px",
            borderRadius: "29px",
          }}
        >
          <img
            src={profileImage || defaultImage}
            alt={createdByName}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = defaultImage;
            }}
            width="14"
            height="14"
            style={{ borderRadius: "50%" }}
          />
          <span className="hover-calender">
            {createdByName}

            <div className="hover-content-bx">
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <span className="leave-hover">
                  <div className="leave-popup">
                     {!halfDay && <span>Half Day : No</span>}
                      {halfDay && (
                      <>
                        {halfPreferenceStatus === "1" && <span>Half Day : First Half</span>}
                        {halfPreferenceStatus === "2" && <span>Half Day : Second Half</span>}
                      </>
                    )}

                    {/* {!halfDay && (
                      <p>
                        <strong>Half:</strong>{" "}
                        {halfPreferenceStatus == 1
                          ? "Second Half"
                          : "First Half"}
                      </p>
                    )} */}
                    {upDateLeaveStatus && (
                      <p>
                        <strong>Status:</strong> {upDateLeaveStatus}
                      </p>
                    )}

                  </div>
                </span>
              </div>
            </div>
          </span>
        </div>
      );
    }
  };

  const handleEventDrop = (info) => {
    const updatedEvents = events.map((event) =>
      event.id === info.event.id
        ? { ...event, start: info.event.start }
        : event,
    );
    setEvents(updatedEvents);
  };

  function handleDateSelect(selectInfo) {
    if (
      selectInfo.view.type === "timeGridWeek" ||
      selectInfo.view.type === "timeGridDay"
    ) {
      selectInfo.view.calendar.unselect();
      setState({ selectInfo, state: "create" });
      setStart(selectInfo.start);
      setEnd(selectInfo.end);
      setModal(true);
    }
  }

  function handleEventClick(clickInfo) {
    setState({ clickInfo, state: "update" });
    setTitle(clickInfo.event.title);
    setStart(clickInfo.event.start);
    setEnd(clickInfo.event.end);
    setModal(true);
  }

  function handleEvents(events) {
    setCurrentEvents(events);
  }

  const handleInputChangeFeature = (e) => {
    setIsChecked(e.value);
    setLeaveData([]);
    setLeaveEvents([]);
    setResources([]);

    if (e.value === false) {
      getLeaveData(3, "U", 0);
    } else {
      getLeaveData(1, "U", userDetails?.EmpId);
    }
  };

  const calendarRef = useRef(null);
  const handleDatesSet = (arg) => {
    setFilterStartDate(arg?.startStr);
    setFilterEndDate(arg?.endStr);
    const calendarApi = calendarRef.current?.getApi();
    if (!calendarApi) return;
    const today = moment(new Date());
    const minMonth = today.clone().startOf("month").subtract(1, "months");
    const viewStartDate = moment(arg.start);
    const prevButton = document.querySelector(".fc-prev-button");
    if (!prevButton) return;
    if (viewStartDate.isSameOrBefore(minMonth, "month")) {
      prevButton.setAttribute("disabled", "true");
      prevButton.style.opacity = "0.5";
    } else {
      prevButton.removeAttribute("disabled");
      prevButton.style.opacity = "1";
    }
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="row g-3">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Leave & WFH Calendar</h2>
              <p className="text-light">Feature leave and WFH</p>
            </div>
            <div className="rightside-tabs">
              <div className="me-2 select-futurepost">
                <label>{isChecked ? "Mine" : "Team"}</label>
                <div className="ml-auto d-flex">
                  <InputSwitch
                    checked={isChecked}
                    onChange={(e) => handleInputChangeFeature(e)}
                  />
                </div>
              </div>
              <Link to={`/${backPath}`}>
                <button className="back-newticket w-auto float-right">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-left-short"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                    />
                  </svg>{" "}
                  Back
                </button>
              </Link>
            </div>
          </div>
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            editable={false}
            selectable={false}
            selectMirror={false}
            dayMaxEvents={3}
            eventContent={renderEventContent}
            select={handleDateSelect}
            eventClick={handleEventClick}
            eventDrop={handleEventDrop}
            eventsSet={() => handleEvents(events)}
            initialView="dayGridMonth"
            headerToolbar={{
              left: "prev,next",
              center: "title",
              right: "",
            }}
            allDaySlot={true} // Ensure all-day slot is enabled for all-day events
            events={leaveEvents}
            resources={resources}
            datesSet={handleDatesSet}
          />
        </div>
      </div>
      {Isloading ? <ComponentLoader /> : ""}
    </div>
  );
};

export default MyCalendarComponent;
